import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import formatPrice from 'utils/formatPrice';

const styles = theme => ({
  tableCellInsuranceStatusInactive: {
    color: theme.palette.validation[500],
  },
});

const PatientsDialogInsurancesListItem = ({ onClick, classes, ...otherProps }) => (
  <TableRow
    hover
    {...onClick ? {
      onClick,
      onKeyDown: (event) => {
        if (event.key === 'Enter') {
          onClick();
        }
      },
      tabIndex: 0,
    } : {}}
  >
    <TableCell>
      {otherProps['Insurance Info']['Payer Name']}
    </TableCell>
    <TableCell>
      {otherProps['Insurance ID']}
    </TableCell>
    <TableCell>
      {otherProps['Effective From']}
      {(otherProps['Effective From'] && otherProps['Effective To']) && ' - '}
      {otherProps['Effective To']}
    </TableCell>
    <TableCell>
      {otherProps['Copay Type'] === 'Fixed' ? (
        formatPrice(otherProps['Copay Amount'])
      ) : (
        `${otherProps['Copay Amount']}%`
      )}
    </TableCell>
    <TableCell
      className={classNames({
        [classes.tableCellInsuranceStatusInactive]: otherProps['Insurance Status'] === 'Inactive',
      })}
    >
      {otherProps['Insurance Status']}
    </TableCell>
  </TableRow>
);

PatientsDialogInsurancesListItem.propTypes = {
  'Insurance Info': PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'Payer Name': PropTypes.string.isRequired,
  }).isRequired,
  'Insurance ID': PropTypes.string.isRequired,
  'Effective From': PropTypes.string,
  'Effective To': PropTypes.string,
  'Copay Amount': PropTypes.string,
  'Copay Type': PropTypes.string,
  'Insurance Status': PropTypes.string.isRequired,
  onClick: PropTypes.func,
  classes: PropTypes.shape({
    tableCellInsuranceStatusInactive: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsDialogInsurancesListItem.defaultProps = {
  onClick: null,
  'Effective From': null,
  'Effective To': null,
  'Copay Amount': null,
  'Copay Type': null,
};

export default withStyles(styles)(PatientsDialogInsurancesListItem);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogInsurancesListItem.js